import React, { FC } from "react";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ChevronRight: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faChevronRight} {...props} />
);
